import { useState } from 'react'
import { useHistory } from 'react-router'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Alert, { ActionsOptType } from '../../components/Alert'
import DialogContentText from '@material-ui/core/DialogContentText'

// Define IDialogOpen interface
interface IDialogOpen {
  open: boolean
  setOpen: (newState: boolean) => void
}
  
/**
 * This method is used to show dialog and redirect app
 * @param {Boolean} open
 * @param {Function} setOpen
 * @return {RegisterSuccessDialog}
 */
const RegisterSuccessDialog = ({
    open,
    setOpen,
  }: IDialogOpen): JSX.Element => {
  const history = useHistory()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to close dialog
   * @Return {void}
  */
  const handleClose = () => {
    setOpen(false)
  }
  
  /**
   * This method is used to redirect the app
   * @Return {void}
  */
  const EndService = async () => {
    history.push('/docengine')
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <DialogContent>
        <DialogContentText style={{whiteSpace: 'pre-line'}}>
          { `!Bienvenido! \n
            Estamos muy felices de que te unas a la familia Justiexpress. \n
            Hemos enviado un email de verificación de cuenta a tu correo electrónico, por favor sigue los pasas allí indicados para validar tu cuenta.`
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={EndService} color="primary">
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RegisterSuccessDialog